<template>
  <div
    class="w-full text-[var(--text)] gap-2 sm:gap-3 lg:gap-4 p-1 sm:p-4 lg:p-6 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col"
  >
    <!-- Header with responsive layout -->
    <div
      class="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-2"
    >
      <h3
        class="text-[--titulo] text-lg sm:text-xl lg:text-2xl font-semibold truncate"
      >
        {{ title }}
      </h3>
      <div
        class="flex flex-row sm:flex-row gap-2 justify-start sm:justify-center items-center w-full sm:w-auto"
      >
        <AppButton
          v-bind:visibility="true"
          :font_size="12"
          style="background-color: var(--button); color: var(--label)"
          left_icon="fa-solid fa-pen-to-square"
          text="Salvar"
          emitType="select"
          @select="save_table1"
          class="flex-1 sm:flex-none min-w-0"
        />
        <AppButton
          class="flex-shrink-0"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="23"
          :height="23"
        />
      </div>
    </div>

    <!-- Tables container with responsive spacing -->
    <div class="flex flex-col gap-3 sm:gap-4 lg:gap-6">
      <!-- First Table with responsive wrapper -->
      <div class="w-full overflow-hidden">
        <AppTable
          :visibility="true"
          :show="true"
          :table_data="table1_data"
          :table_title="table1.title"
          :hiddenHeaders="hiddenHeaders"
          :noClose="true"
          :multiSelect="{
            show: true,
            isActive: true,
            buttons: {
              delete: {
                show: true,
                enabled: true,
                text: '',
                color: 'var(--obrigatorio)',
                icon: 'fa-solid fa-trash-alt',
                emit: 'remove-selected-rows',
              },
            },
          }"
          @row-clicked="remove_entry"
          :confirmationProps="{
            show: true,
            message: 'Eliminar local de instalação?',
          }"
          :page_display="responsivePageSize"
          @remove-selected-rows="remove_entries"
          class="min-w-0 w-full"
        />
      </div>

      <!-- Second Table with responsive wrapper -->
      <div class="w-full overflow-hidden">
        <AppTable
          :visibility="true"
          :show="true"
          :table_data="table2_data"
          :table_title="table2.title"
          :hiddenHeaders="hiddenHeaders"
          :noClose="true"
          :multiSelect="{
            show: true,
            isActive: true,
            buttons: {
              add: {
                show: true,
                enabled: true,
                text: '',
                color: '#ff9b05',
                icon: 'fa-solid fa-pen-to-square',
                emit: 'send-selected-rows',
              },
              delete: {
                show: true,
                enabled: false,
                text: '',
                color: 'red',
                icon: 'fa-solid fa-trash-alt',
                emit: 'remove-selected-rows',
              },
            },
          }"
          @row-clicked="add_entry"
          :confirmationProps="{
            show: true,
            message: 'Adicionar Local de instalação?',
          }"
          :page_display="responsivePageSize"
          @send-selected-rows="add_entries"
          class="min-w-0 w-full"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppTable from "@/components/tables/table.vue";
import AppButton from "@/components/updated/button.vue";
import axios from "axios";
import { toast } from "vue3-toastify";

export default {
  name: "multiTable",
  components: {
    AppTable,
    AppButton,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    table1: {
      type: Object,
      default: () => ({
        title: "Tabela 1",
        type: "entity1",
        rotas: {
          create_url: "",
          update_url: "",
          delete_url: "",
          select_all_url: "",
        },
      }),
    },
    table2: {
      type: Object,
      default: () => ({
        title: "Tabela 2",
        type: "entity2",
        rotas: {
          create_url: "",
          update_url: "",
          delete_url: "",
          select_all_url: "",
        },
      }),
    },
  },

  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,

      table1_data: [],
      table2_data: [],

      table1_original_data: [],

      // Window width for responsive breakpoints
      windowWidth: window.innerWidth,
      hiddenHeaders: [
        "id",
        "cliente_id",
        "subCliente_id",
        "endereco_id",
        "local_instalacao_antigo_id",
        "tpZona_id",
        "tpIva_id",
        "contrato_id",
        "tabelapreco_id",
        "manuTiExtintor",
        "manuTiCarretel",
        "manuTiRia",
        "faturacaoAgregada",
        "proforma",
        "purchaseOrder",
        "encomendaAutomatica",
        "tempoArranque",
        "conetividade",
      ],
    };
  },

  computed: {
    // Responsive page size based on screen width
    responsivePageSize() {
      if (this.windowWidth < 640) {
        // Mobile
        return 3;
      } else if (this.windowWidth < 1024) {
        // Tablet
        return 4;
      }
      return 5; // Desktop
    },

    // Check if we're on mobile
    isMobile() {
      return this.windowWidth < 640;
    },

    // Check if we're on tablet
    isTablet() {
      return this.windowWidth >= 640 && this.windowWidth < 1024;
    },
  },

  created() {
    this.get_datas();
  },

  mounted() {
    // Add window resize listener for responsive behavior
    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    // Handle window resize for responsive behavior
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    close() {
      this.$emit("close");
    },
    remove_entry(row) {
      this.table1_data = this.table1_data.filter((item) => item.id !== row.id);
    },
    add_entry(row) {
      console.log("Row:", row);

      const isDuplicate = this.table1_data.some((item) => item.id === row.id);
      if (!isDuplicate) {
        this.table1_data.push(row);
        this.table1_data.sort((a, b) => a.id - b.id);
      } else {
        console.log("Duplicated item");
      }
    },

    add_entries(rows) {
      rows.forEach((row) => {
        const isDuplicate = this.table1_data.some((item) => item.id === row.id);
        if (!isDuplicate) {
          this.table1_data.push(row);
          this.table1_data.sort((a, b) => a.id - b.id);
        } else {
          console.log("Duplicated item");
        }
      });
    },

    remove_entries(rows) {
      rows.forEach((row) => {
        this.table1_data = this.table1_data.filter(
          (item) => item.id !== row.id
        );
      });
    },

    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },

    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },

    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },

    async get_datas() {
      const table1 = await this.select_all(this.table1.rotas.select_all_url);
      const table2 = await this.select_all(this.table2.rotas.select_all_url);

      this.table1_original_data = table1.slice().sort((a, b) => a.id - b.id);

      this.table1_data = table1.sort((a, b) => a.id - b.id);
      this.table2_data = table2.sort((a, b) => a.id - b.id);

      if (this.table1.type === "utilizador") {
        this.table1_data = table1
          .map((obj) =>
            Object.fromEntries(
              Object.entries(obj).filter(([key]) =>
                ["id", "user", "status"].includes(key)
              )
            )
          )
          .sort((a, b) => a.id - b.id);
      }
      if (this.table2.type === "utilizador") {
        this.table2_data = table2
          .map((obj) =>
            Object.fromEntries(
              Object.entries(obj).filter(([key]) =>
                ["id", "user", "status"].includes(key)
              )
            )
          )
          .sort((a, b) => a.id - b.id);
      }
      // this.table1_data = await this.select_all(this.table1_select_all_url)
      // this.table2_data = await this.select_all(this.table2_select_all_url)
    },

    async save_table1() {
      console.log("original_data:", this.table1_original_data);
      console.log("table1_data:", this.table1_data);
      // this.$emit('save', this.table1_data)

      const deletePromises = this.table1_original_data.map(async (item) => {
        if (!this.table1_data.some((row) => row.id === item.id)) {
          const data = {};
          if (this.table1.type === "tabelaPrecos") {
            data.nome = item.nome;
          }
          data[this.table1.owner.nome] = 0;
          const res = await this.update(
            `${this.table1.rotas.update_url}/${item.id}/`,
            data
          );
          if (res) {
            console.log("data eliminated");
          }
          // await this.remove(`${this.table1.rotas.delete_url}/${item.id}`)
        }
      });

      const addPromises = this.table1_data.map(async (item) => {
        if (!this.table1_original_data.some((row) => row.id === item.id)) {
          const data = {};
          if (this.table1.type === "tabelaPrecos") {
            data.nome = item.nome;
          }
          data[this.table1.owner.nome] = this.table1.owner.id;
          const res = await this.update(
            `${this.table1.rotas.update_url}/${item.id}/`,
            data
          );
          if (res) {
            console.log("data added");
          }
          // await this.create(item, this.table1.rotas.create_url)
        }
      });

      const res = await Promise.all([...deletePromises, ...addPromises]);
      if (res) {
        toast.success(`Dados salvos com sucesso!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      } else {
        toast.error(`Erro ao salvar dados!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
      await this.get_datas();
    },
  },
};
</script>
